export default __webpack_public_path__ + "static/media/segoeuib.e3a2d710.ttf";